import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Capital-partner entry strip. Sits near the bottom of pages above the footer
 * to redirect lender / investor / acquirer traffic that lands on owner pages.
 */
export default function PartnerEntry() {
  return (
    <section className="oc-section oc-section--tight oc-section--no-border">
      <div className="oc-shell">
        <div className="oc-row-sb" style={{ alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
          <div>
            <div className="oc-eyebrow-gray" style={{ marginBottom: 6 }}>
              Lender, investor, or acquirer?
            </div>
            <div
              className="oc-h3"
              style={{ fontSize: 22, letterSpacing: '-0.01em' }}
            >
              Apply to access deal flow on OfficerCapital.
            </div>
          </div>
          <Link to="/partners" className="oc-btn oc-btn--ghost">
            Apply for access →
          </Link>
        </div>
      </div>
    </section>
  );
}
